export function buildStringUsingTemplate(template, templateVariables) {
    let string = template;
    for (const [key, value] of Object.entries(templateVariables)) {
        string = string.replace(new RegExp('\\${' + key + '}', 'g'), value);
    }
    return string;
}
export function applyTemplateVariablesToFormData(formData, templateVariables) {
    formData.subject = buildStringUsingTemplate(formData.subject, templateVariables);
    if (formData === null || formData === void 0 ? void 0 : formData.title) {
        formData.title = buildStringUsingTemplate(formData.title, templateVariables);
    }
    if (formData === null || formData === void 0 ? void 0 : formData.textMessage) {
        formData.textMessage = buildStringUsingTemplate(formData.textMessage, templateVariables);
    }
    if (formData === null || formData === void 0 ? void 0 : formData.htmlMessage) {
        formData.htmlMessage = buildStringUsingTemplate(formData.htmlMessage, templateVariables);
    }
    if (formData === null || formData === void 0 ? void 0 : formData.voiceMessage) {
        formData.voiceMessage = buildStringUsingTemplate(formData.voiceMessage, templateVariables);
    }
    if (formData === null || formData === void 0 ? void 0 : formData.responseOptions) {
        formData.responseOptions = formData.responseOptions.map((option) => {
            const optionValue = Object.assign({}, option);
            optionValue.text = buildStringUsingTemplate(option.text, templateVariables);
            return optionValue;
        });
    }
}
